import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface Option {
  value: string;
  label: string;
}
interface SelectProps {
  label?: string;
  options: Option[];
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  error?: string;
  required?: boolean;
  name?: string;
  id?: string;
}
const Select: React.FC<SelectProps> = ({
  label,
  options,
  value,
  onChange,
  error,
  required = false,
  name,
  id
}) => {
  const selectId = id || name || Math.random().toString(36).substring(2, 9);
  return <div className="mb-4 relative" data-id="element-183">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-184">
          {label} {required && <span className="text-red-500" data-id="element-185">*</span>}
        </label>}
      <div className="relative" data-id="element-186">
        <select id={selectId} name={name} value={value} onChange={onChange} required={required} className={`appearance-none w-full px-3 py-2 border ${error ? 'border-red-500' : 'border-gray-300'} bg-white rounded-md shadow-sm focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]`} data-id="element-187">
          {options.map(option => <option key={option.value} value={option.value} data-id="element-188">
              {option.label}
            </option>)}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-189">
          <ChevronDownIcon size={18} className="text-gray-500" data-id="element-190" />
        </div>
      </div>
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-191">{error}</p>}
    </div>;
};
export default Select;